<template>
  <!-- ▼SideMenu Container -->
  <div
    :class="{ 'is-opened': isOpened, 'boss-menu-close': !expandsSidebar }"
    class="boss-admin-sidemenu-container"
    data-test="expand"
  >
    <div
      class="boss-admin-sidemenu-toggle"
      @click="toggle()"
    >
      <div class="boss-admin-sidemenu-toggle-bar" />
      <div class="boss-admin-sidemenu-toggle-bar boss-admin-sidemenu-toggle-bar-2" />
      <div class="boss-admin-sidemenu-toggle-bar boss-admin-sidemenu-toggle-bar-3" />
    </div>
    <div class="boss-admin-sidemenu-wrap">
      <nav class="boss-admin-sidemenu">
        <ul
          id="boss-dropdown-control"
          class="vertical dropdown menu boss-admin-sidemenu-list"
          data-dropdown-menu
        >
          <li class="boss-admin-sidemenu-item">
            <router-link
              :class="{ 'boss-active': $route.path.includes('/dashboard') }"
              :to="{ name: 'dashboardTop' }"
              data-test="dashboard-top"
              class="boss-admin-sidemenu-link"
              exact-active-class="boss-active"
            >
              <div class="boss-menu-icon boss-menu-icon-dash">
                <!-- ▼icon dashboard -->
                <span class="boss-icon boss-icon-dashboard" />
                <!-- ▲icon dashboard -->
              </div>
              <div class="boss-menu-name">
                ダッシュボード
              </div>
            </router-link>
          </li>
          <li
            v-if="showEntry"
            data-test="entry-sidemenu-link"
            class="boss-admin-sidemenu-item"
          >
            <router-link
              :class="{ 'boss-active': $route.path.includes('/entries') }"
              :to="{ name: 'entryTop' }"
              data-test="entry-top"
              class="boss-admin-sidemenu-link"
            >
              <div class="boss-menu-icon boss-menu-icon-apply">
                <!-- ▼icon 応募者管理 -->
                <span class="boss-icon boss-icon-apply" />
                <!-- ▲icon 応募者管理 -->
              </div>
              <div class="boss-menu-name">
                応募者管理
              </div>
            </router-link>
          </li>
          <li
            v-if="showScout"
            data-test="scout-sidemenu-link"
            class="boss-admin-sidemenu-item"
          >
            <router-link
              :class="{ 'boss-active': $route.path.includes('/scouts') }"
              :to="{ name: 'scoutTop' }"
              class="boss-admin-sidemenu-link"
              exact-active-class="boss-active"
              data-test="scout-and-liked"
            >
              <div class="boss-menu-icon boss-menu-icon-scoutandlike">
                <!-- ▼icon スカウト -->
                <span class="boss-icon boss-icon-scoutandlike" />
                <!-- ▲icon スカウト -->
              </div>
              <div class="boss-menu-name">
                スカウト
              </div>
            </router-link>
          </li>
          <li
            v-if="isExistsSeminar"
            class="boss-admin-sidemenu-item"
            data-test="seminar-sidemenu-link"
          >
            <router-link
              :class="{ 'boss-active': $route.path.includes('/seminar_entries') }"
              :to="{ name: 'seminarEntryTop' }"
              data-test="seminar-entry-top"
              class="boss-admin-sidemenu-link"
            >
              <div class="boss-menu-icon boss-menu-icon-seminar">
                <!-- ▼セミナー管理 -->
                <span class="boss-icon boss-icon-seminar" />
                <!-- ▼セミナー管理 -->
              </div>
              <div class="boss-menu-name">
                セミナー管理
              </div>
            </router-link>
          </li>
          <li class="boss-admin-sidemenu-item">
            <span
              :class="{'boss-active': $route.path.includes('/job_confirmation')}"
              class="boss-admin-sidemenu-link"
            >
              <div class="boss-menu-icon boss-menu-icon-posting">
                <!-- ▼icon 掲載中の求人原稿 -->
                <span class="boss-icon boss-icon-posting" />
                <!-- ▲icon 掲載中の求人原稿 -->
              </div>
              <div class="boss-menu-name">求人確認<span class="boss-icon-triangle" /></div>
            </span>
            <ul class="vertical menu nested boss-side-submenu">
              <li class="boss-side-submenu-item">
                <router-link
                  :to="{ name: 'jobPrePublished' }"
                  data-test="job-pre-published"
                  class="boss-submenu-link"
                >
                  掲載前の求人
                </router-link>
              </li>
              <li class="boss-side-submenu-item">
                <router-link
                  :to="{ name: 'jobPublished' }"
                  data-test="job-published"
                  class="boss-submenu-link"
                >
                  掲載済みの求人・応募フォームタイプ設定
                </router-link>
              </li>
            </ul>
          </li>
          <li class="boss-admin-sidemenu-item">
            <router-link
              :class="{ 'boss-active': $route.path.includes('/real_intentions') }"
              :to="{ name: 'realIntentionTop' }"
              data-test="real-intention"
              class="boss-admin-sidemenu-link"
            >
              <div class="boss-menu-icon">
                <span class="boss-icon boss-icon-comment-dots-regular pega-icon-reputation-from-employees" />
              </div>
              <div class="boss-menu-name">
                社員からの評判
              </div>
            </router-link>
          </li>
          <li class="boss-admin-sidemenu-item">
            <router-link
              :class="{'boss-active' : $route.path.includes('/interview_information')}"
              :to="{name: 'interviewInformationTop'}"
              data-test="interview"
              class="boss-admin-sidemenu-link"
            >
              <div class="boss-menu-icon boss-menu-icon-interview">
                <!-- ▼面接情報 -->
                <span class="boss-icon boss-icon-interview" />
                <!-- ▲面接情報 -->
              </div>
              <div class="boss-menu-name">
                面接情報
              </div>
            </router-link>
          </li>
          <li class="boss-admin-sidemenu-item">
            <router-link
              :class="{ 'boss-active': $route.path.includes('/interview_candidate') }"
              :to="{ name: 'interviewCandidateDateTop' }"
              data-test="first-interview-candidate-date"
              class="boss-admin-sidemenu-link"
            >
              <div class="boss-menu-icon">
                <span class="boss-icon boss-icon-calendar-check-regular pega-icon-first-interview-candidate-date" />
              </div>
              <div class="boss-menu-name pega-side-menu-first-interview-candidate-date">
                一次面接候補日設定
              </div>
            </router-link>
          </li>
          <li class="boss-admin-sidemenu-item">
            <span
              :class="{'boss-active': $route.path.includes('/settings')}"
              class="boss-admin-sidemenu-link"
            >
              <div class="boss-menu-icon boss-menu-icon-setting">
                <!-- ▼icon 各種設定 -->
                <span class="boss-icon boss-icon-setting" />
                <!-- ▲icon 各種設定 -->
              </div>
              <div class="boss-menu-name">各種設定<span class="boss-icon-triangle" /></div>
            </span>
            <ul class="vertical menu nested boss-side-submenu">
              <li
                v-if="showAccounts"
                data-test="account-sidemenu-link"
                class="boss-side-submenu-item"
              >
                <router-link
                  :to="{ name: 'settingAccounts' }"
                  data-test="setting-accounts"
                  class="boss-submenu-link"
                >
                  アカウント管理
                </router-link>
              </li>
              <li
                v-if="showAllowedIpAddress"
                data-test="ip-address-sidemenu-link"
                class="boss-side-submenu-item"
              >
                <router-link
                  :to="{ name: 'settingIpAddress' }"
                  data-test="ip-address"
                  class="boss-submenu-link"
                >
                  閲覧制限用IPアドレス設定
                </router-link>
              </li>
              <li class="boss-side-submenu-item">
                <router-link
                  :to="{ name: 'settingScoutTemplates' }"
                  data-test="scout-template"
                  class="boss-submenu-link"
                >
                  スカウト＿テンプレート設定
                </router-link>
              </li>
              <li class="boss-side-submenu-item">
                <router-link
                  :to="{ name: 'settingMemberAttributes' }"
                  data-test="member-attributes"
                  class="boss-submenu-link"
                >
                  スカウト＿一覧画面の表示情報の設定
                </router-link>
              </li>
              <li
                v-if="showSettingsSelection"
                class="boss-side-submenu-item"
                data-test="selection-sidemenu-link"
              >
                <router-link
                  :to="{ name: 'settingSelections' }"
                  data-test="screening-process"
                  class="boss-submenu-link"
                >
                  応募者管理＿選考フェーズ・ステータス設定
                </router-link>
              </li>
              <li class="boss-side-submenu-item">
                <router-link
                  :to="{ name: 'settingMessageTemplates' }"
                  data-test="message-template"
                  class="boss-submenu-link"
                >
                  応募者管理＿テンプレート設定
                </router-link>
              </li>
              <li class="boss-side-submenu-item">
                <router-link
                  :to="{ name: 'settingEntryColumns' }"
                  data-test="setting-entry-columns"
                  class="boss-submenu-link"
                >
                  応募者管理＿一覧画面の表示情報の設定
                </router-link>
              </li>
              <li class="boss-side-submenu-item">
                <router-link
                  :to="{ name: 'settingEntryAutoReply' }"
                  data-test="setting-entry-auto-reply"
                  class="boss-submenu-link"
                >
                  応募者管理＿自動受付メッセージ設定
                </router-link>
              </li>
            </ul>
          </li>
          <li class="boss-admin-sidemenu-item">
            <a
              target="_blank"
              data-test="user-help"
              href="/help/index.html"
              class="boss-admin-sidemenu-link"
            >
              <div class="boss-menu-icon boss-menu-icon-apply">
                <!-- ▼icon ユーザーガイド -->
                <span class="boss-icon boss-icon-question" />
                <!-- ▲icon ユーザーガイド -->
              </div>
              <div class="boss-menu-name">ユーザーガイド</div>
            </a>
          </li>
        </ul>
      </nav>
      <a
        class="boss-admin-sidemenu-openandclose"
        data-test="menu-open-and-close"
        @click="menuOpenClose"
      >
        <div class="boss-admin-sidemenu-link">
          <div class="boss-menu-icon boss-menu-icon-open">
            <!-- ▼icon メニュー開閉 -->
            <span class="boss-icon boss-icon-close" />
            <!-- ▲icon メニュー開閉 -->
          </div>
          <div class="boss-menu-name">メニューを閉じる</div>
        </div>
      </a>
      <div
        v-show="expandsSidebar"
        data-test="information-second"
        v-html="informationSecond"
      />
    </div>
  </div>
  <!-- ▲SideMenu Container -->
</template>

<script>
import Foundation from 'foundation-sites'
import jQuery from 'jquery'
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      isOpened: false,
      informationSecond: ''
    }
  },
  computed: {
    ...mapGetters([
      'showScout',
      'showAccounts',
      'showEntry',
      'showAllowedIpAddress',
      'expandsSidebar',
      'showSettingsSelection',
      'isExistsSeminar'
    ])
  },
  created () {
    this.fetchContentsInformationSecond()
  },
  mounted () {
    this.Sidebar = new Foundation.DropdownMenu(jQuery('#boss-dropdown-control'), {
      // These options can be declarative using the data attributes
      hoverDelay: 200
    })
  },
  destroyed () {
    this.Sidebar.destroy()
  },
  methods: {
    menuOpenClose () {
      this.toggleExpandsSidebar()
    },
    toggle () {
      this.isOpened = !this.isOpened
    },
    ...mapActions([
      'toggleExpandsSidebar'
    ]),
    fetchContentsInformationSecond () {
      this.$http.secured.get('/company/contents/bko_information_second').then((response) => {
        this.$set(this, 'informationSecond', response.data)
      })
    }
  }
}
</script>
